import React from 'react'
import UnavailableBlockTable from "../unavailable-block-table/UnavailableBlockTable"

const UnavailableBlockSettings = (props) => {
    return (
        <div>
            <div title='Closed/Away Time'>
                <UnavailableBlockTable />
            </div>
        </div>
    )
}

export default UnavailableBlockSettings
